<template>
    <div class="message-box" v-if="isShow">
        <div class="msg-box">
            <header>{{title}}</header>
            <div class="content">
                {{content}}
            </div>
            <div class="btn cancel" v-if="showCancelBtn" @click="closeMsgBox">取消</div>
            <div class="btn sure" :class="showCancelBtn ? '' : 'noCancel'" @click="clickSure">{{btnContent}}</div>
        </div>
        <div class="modal" v-show="showModal"></div>
    </div>
</template>

<script>
    export default {
        name: 'messageBox',
        props: {
            title: {
                type    : String,
                default : '温馨提示'
            },
            content: {
                type    : String,
                default : '信息内容'
            },
            btnContent: {
                type    : String,
                default : '确定'
            },
            callBack: {
                type    : Function,
                default : function(){}
            },
            showModal: {
                type    : Boolean,
                default : false
            },
            showCancelBtn: {
                type    : Boolean,
                default : false
            }
        },
        data() {
            return {
                isShow: true,
            }
        },
        mounted() {

        },
        methods: {
            closeMsgBox: function() {
                this.isShow = false;
            },
            clickSure: function() {
                this.callBack();
                this.isShow = false;
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.message-box {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    .msg-box {
        position: relative;
        z-index: 100;
        box-sizing: border-box;
        overflow:hidden;
        width: 520px;
        margin: 300px auto 0;
        border-radius: 30px;
        background: #fff;
        header {
            margin-top: 24px;
            font-size: 36px;
            font-weight: 600;
            text-align: center;
        }
        .content {
            margin-top: 34px;
            padding: 0 44px;
            line-height: 48px;
            text-indent: 56px;
            font-size: 28px;
        }
        .btn {
            float: left;
            box-sizing: border-box;
            width: 50%;
            margin-top: 28px;
            padding: 18px;
            border-top: 2px solid #ccc;
            font-size: 36px;
            color: #0074ff;
            text-align: center;
        }
        .sure {
            background: #2099ff;
            color: #fff;
        }
        .noCancel {
            width: 100%;
        }
    }
    .modal {
        position: absolute;
        top: 0;
        z-index: 99;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.7);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/messageBox/messageBox.vue